"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonType = exports.ButtonSize = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../Text");
const Spinner_1 = require("../Spinner");
const clsx_1 = __importDefault(require("clsx"));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["SLIM"] = "slim";
    ButtonSize["MD"] = "md";
    ButtonSize["LG"] = "lg";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["PRIMARY"] = "primary";
    ButtonType["SECONDARY"] = "secondary";
    ButtonType["DESTRUCTIVE"] = "destructive";
    ButtonType["QUIET"] = "quiet";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
exports.Button = react_1.default.forwardRef(({ children, size = ButtonSize.MD, type = ButtonType.PRIMARY, disabled = false, fullWidth = false, name, left, right, testId, onClick, className, loading, submit, }, ref) => {
    const stylesBySize = {
        slim: 'px-3 py-1',
        md: 'px-4 py-2',
        lg: 'px-5 py-3',
    };
    const stylesByType = {
        primary: 'bg-cta-primary-default hover:bg-cta-primary-hover',
        secondary: 'bg-cta-secondary-default hover:bg-cta-secondary-hover',
        destructive: 'bg-cta-destructive-default hover:bg-cta-destructive-hover',
        quiet: 'bg-cta-quiet-default hover:bg-cta-quiet-hover',
    };
    const disabledStylesByType = {
        primary: 'bg-cta-primary-disabled hover:bg-cta-primary-disabled',
        secondary: 'bg-cta-secondary-disabled hover:bg-cta-secondary-disabled',
        destructive: 'bg-cta-destructive-disabled hover:bg-cta-destructive-disabled',
        quiet: 'bg-cta-quiet-disabled hover:bg-cta-quiet-disabled',
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { ref: ref, "data-testid": testId, name: name, disabled: disabled, type: submit ? 'submit' : 'button', className: (0, clsx_1.default)(className, 'inline-flex items-center', 'rounded-cta', stylesByType[type], stylesBySize[size], (disabled && disabledStylesByType[type]) || '', disabled ? 'cursor-default' : 'cursor-pointer', fullWidth && 'w-full', left && 'justify-start', right && 'justify-end', !left && !right && 'justify-center'), onClick: (e) => {
                if (disabled)
                    e.stopPropagation();
                if (!disabled && onClick)
                    onClick(e);
            } },
            (typeof children === 'string' || children instanceof String) && (react_1.default.createElement(react_1.default.Fragment, null,
                loading && react_1.default.createElement(Spinner_1.Spinner, { className: "mr-2" }),
                react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BUTTON, className: (0, clsx_1.default)(disabled ? 'cursor-default' : 'cursor-pointer', type === ButtonType.QUIET && 'text-gray-300'), disabled: disabled }, children))),
            typeof children !== 'string' && children)));
});
//# sourceMappingURL=Button.js.map